/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The ChartsDataSalary model module.
* @module model/ChartsDataSalary
* @version 1.0.0
*/
export default class ChartsDataSalary {
    /**
    * Constructs a new <code>ChartsDataSalary</code>.
    * @alias module:model/ChartsDataSalary
    * @class
    * @param salary {Number} 
    */

    constructor(salary) {
        

        
        

        this['salary'] = salary;

        
    }

    /**
    * Constructs a <code>ChartsDataSalary</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ChartsDataSalary} obj Optional instance to populate.
    * @return {module:model/ChartsDataSalary} The populated <code>ChartsDataSalary</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ChartsDataSalary();

            
            
            

            if (data.hasOwnProperty('salary')) {
                obj['salary'] = ApiClient.convertToType(data['salary'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Number} salary
    */
    salary = undefined;








}


